import { getFormedEltTranslation } from './getFormedEltTranslation'

export const getEltDocFormatTranslation = (eltType: number) => {
  return getFormedEltTranslation(`versions-elt-type-v${eltType}`)
}
